import { forwardRef, SelectHTMLAttributes, useEffect, useState } from "react";
import { useFormFieldState } from "../FormComponentHooks";
import styles from "./FormField.module.less";
import { extractValueProps, FormFieldProps } from "./FormFieldProps";

interface AdditionalSelectProps {
  options: SelectOption[];
}

export interface SelectOption<T extends string = string> {
  displayValue: string;
  value: T;
}

export type SelectProps =
  & SelectHTMLAttributes<HTMLSelectElement>
  & FormFieldProps<string>
  & AdditionalSelectProps;

const PLACEHOLDER_VALUE = "";
export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  function Select(props, ref) {
    const [valueProps, { options, placeholder, ...selectProps }] = extractValueProps(props);
    const [value, setValue] = useFormFieldState(valueProps, placeholder ? PLACEHOLDER_VALUE : options[0]?.value);

    const [placeholderClass, setPlaceholderClass] = useState("");
    useEffect(() => setPlaceholderClass(value === PLACEHOLDER_VALUE ? styles.placeholder : ""), [value]);
    const className = `${styles.select} ${placeholderClass}`;

    return (
      <select
        ref={ref}
        className={className}
        {...selectProps}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      >
        {placeholder && <option className={styles.placeholder} value={PLACEHOLDER_VALUE}>{placeholder}</option>}
        {props.options.map((option) => <option key={option.value} value={option.value}>{option.displayValue}</option>)}
      </select>
    );
  },
);
